<template>
    <div id="forum_items">
        <div v-for="(item, index) in items.topic_list.topics" class="forum-item">
            <a v-bind:href="'https://forum.dnum.unistra.fr/t/' + item.slug" target="_blank">
                <h3>
                    <span class="badge badge-default" title="Réponses">{{ item.posts_count }}</span>
                    <span class="item-title">{{item.title}}</span>
                </h3>
                <div class="creation-date">{{ item.created_at | moment}}</div>
                <div class="excerpt" v-html="item.excerpt"></div>
            </a>
        </div>
        <div class="forum-all">
            <p class="text-center">
                <a href="https://forum.dnum.unistra.fr" class="btn btn-primary">Consulter tous les sujets du forum</a>
            </p>
        </div>
        <div style="display: none" aria-hidden="true">Version : {{ version }}</div>
    </div>
</template>


<script>
    import moment from 'moment';

    export default {
        name: "forum",
        data() {
            return {
                items: {"topic_list":""},
                version: process.env.VERSION
            }
        },
        created: function () {
            this.fetchData();
        },
        methods: {
            fetchData: function () {
                var self = this;
                this.$http.get(portal_conf["forum"]).then(response => {
                    self.items = response.body;
                }, response => {
                    console.error("Error during retrieving data");
                    console.error(response);
                });

            },
        },
        filters: {
            moment: function (date) {
                return moment(date).locale('fr').format('Do MMMM YYYY h[h]mm');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/forum/Forum.vue